import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalComponentBaseProps } from '@pcmp/react-providers';

import Button from '@ingka/button';
import { Prompt, ModalHeader, ModalFooter } from '@ingka/modal';

type PromptModalProps = ModalComponentBaseProps & {
  confirm: () => void;
  showNotificationDisclaimer?: boolean;
  isBulkDelete?: boolean;
};

const DeleteQrPrompt: FC<PromptModalProps> = ({
  handleDismiss,
  confirm,
  showNotificationDisclaimer,
  isBulkDelete,
  ...rest
}) => {
  const { t } = useTranslation();
  const handleConfirm = () => {
    handleDismiss();
    confirm();
  };

  return (
    <Prompt
      {...rest}
      aria-label="Accessibility header for a modal"
      className="example-prompt-override"
      footer={
        <ModalFooter>
          <Button
            data-testid="prompt-cancel"
            text={t('label.goBack')}
            type="secondary"
            onClick={handleDismiss}
          />
          <Button
            data-testid="prompt-confirm"
            text={t('page.codes.detail.deleteCodeConfirm')}
            type="danger"
            onClick={handleConfirm}
          />
        </ModalFooter>
      }
      header={<ModalHeader ariaCloseTxt="Close button text" />}
      title={t(
        `page.codes.detail.deleteCode${isBulkDelete ? 's' : ''}Confirmation`
      )}
      titleId="delete-code-prompt"
    >
      {showNotificationDisclaimer && (
        <p>
          {t(
            `page.codes.detail.deleteCode${isBulkDelete ? 's' : ''}Notification`
          )}
        </p>
      )}
    </Prompt>
  );
};

export default DeleteQrPrompt;
